import SvgIcon from "../../../../../../parts/SvgIcon";

export const ActionsButtons = ({
  onAddSet,
  addSetImgSize,
  onRemoveSet,
  removeSetImgSize,
  onDiscardSet,
  isTemp,
  extraCondition = true,
}) => {
  const addButton = (
    <button type="button" data-button-type="secondary" onClick={onAddSet}>
      <img
        src="/img/new-icons/add-gradient-icon.svg"
        height={addSetImgSize}
        width={addSetImgSize}
        alt="add set"
      />
    </button>
  );

  if (isTemp)
    return (
      <td className="actions">
        {addButton}
        <button
          type="button"
          data-button-type="secondary"
          onClick={onDiscardSet}
        >
          <SvgIcon src="/img/new-icons/red-cross-20px.svg" noFilterOnLight />
        </button>
      </td>
    );

  if (extraCondition)
    return (
      <td className="actions">
        {addButton}
        <button
          type="button"
          data-button-type="secondary"
          onClick={onRemoveSet}
        >
          <img
            src="/img/new-icons/red-trash.svg"
            height={removeSetImgSize}
            width={removeSetImgSize}
            alt="remove set"
          />
        </button>
      </td>
    );

  return null;
};
